module.exports = __webpack_public_path__ + "img/color_block_6.02b0ee2a.svg";